import { trackEvent } from '@fs/zion-analytics'

const PersonViewerInitialState = { isLoading: true, tabContentOverflow: 'auto' }

const PersonViewerReducer = (state, action) => {
  const change = { ...state }
  switch (action.type) {
    case 'INIT_PersonViewer': {
      Object.assign(change, action.data)
      change.isLoading = false
      trackEvent({ event_name: action.type })
      break
    }
    case 'SET_LOCK_MEMORIES': {
      change.lockMemories = action.data.lockMemories
      break
    }
    case 'SET_TAB_CONTENT_OVERFLOW': {
      change.tabContentOverflow = action.data.tabContentOverflow
      break
    }
    default: {
      console.error(`ERROR: Unhandled action type: ${action.type}`) // eslint-disable-line
    }
  }

  return { ...change }
}

export { PersonViewerInitialState, PersonViewerReducer }
